import { useCallback } from 'react';
import { GetAccessRightsResponse, GetRolesResponse } from '@uniqkey-backend-partner/api-client';
import { useApiClients } from '../../contexts/APIClientsContext';
import { dataExtractor } from '../../helpers/apiClients';
import { TGetACLsByRoleMethod, TGetRolesMethod } from './interfaces';

const usePermissionsAPI = () => {
  const { permissionsAPIClient } = useApiClients();

  const getRoles = useCallback<TGetRolesMethod>(
    (params) => {
      const {
        page,
        pageLength,
        cancelToken = undefined,
      } = params;
      return permissionsAPIClient.apiV1PermissionsGetRolesGet(
        page,
        pageLength,
        { cancelToken },
      ).then(dataExtractor<GetRolesResponse>());
    },
    [permissionsAPIClient],
  );

  const getACLsByRole = useCallback<TGetACLsByRoleMethod>(
    (params) => {
      const {
        page,
        pageLength,
        role,
        cancelToken = undefined,
      } = params;
      return permissionsAPIClient.apiV1PermissionsGetAccessRightsGet(
        page,
        pageLength,
        role,
        { cancelToken },
      ).then(dataExtractor<GetAccessRightsResponse>());
    },
    [permissionsAPIClient],
  );

  return ({
    getRoles,
    getACLsByRole,
  });
};

export default usePermissionsAPI;
